import styled from 'styled-components';

export const Action = styled.span`
  width: 2.25rem;
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    border-radius: 50%;
    background: #f2f2f2;
  }
`;
